import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignSummaryItem } from './CampaignSummaryItem';

export const ConnectAudienceStepSummary: FC = () => {
  const { t } = useTranslation();

  return <CampaignSummaryItem index={5} title={t('ALL:connectAudienceSummary')} content={[]} />;
};
